<template>
  <div>
    <b-carousel
      id="carousel-fade"
      v-model="slide"
      :interval="16000"
      controls
      indicators
      background="#ababab"
      img-width="1200"
      img-height="600"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <div v-for="slider in data" :key="slider.sortId">
        <b-carousel-slide
          :caption="slider.title"
          :text="slider.description"
          :img-src="slider.imageURL"
        ></b-carousel-slide>
      </div>
    </b-carousel>
  </div>
</template>

<script>
import { db } from "../firebase/db";
export default {
  data() {
    return {
      slide: 0,
      sliding: null,
      data: []
    };
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    }
  },
  firestore: {
    data: db.collection("homeSliders").orderBy("sortId")
  }
};
</script>

<style lang="scss" scoped></style>
